import { Backdrop, BackdropProps } from "@mui/material";

export default function McpBackDrop({
    ...props
}:BackdropProps){
    return <Backdrop {...props} sx={(theme)=>({zIndex:theme.zIndex.appBar-2})}/>
}